import React from 'react';
import {
  replaceAll,
  printDE_Date,
  replaceAllComplex,
} from '../../../../../mol_function';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { allowKeysAttribute, getShopArticleLabelPrefix } from '../overrides';

import './AttributeTable.css';

export class AttributeItem {
  name;
  value;
}
class AttributeTableProps {
  data;
  details;
  productID;
  domainPrefix;
  attributeShowAllChanged;
}

export default class AttributeTable extends React.Component {
  render() {
    let shopProductIdLabel = getShopArticleLabelPrefix() + '-Artikelnummer';

    let data = JSON.parse(JSON.stringify(this.props.data));
    if (data === undefined) data = [];
    if (!this.props.details) {
      data.push({
        name: shopProductIdLabel,
        value: this.props.productID + '',
      });
    }
    let getProp = (propName) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].name == propName) return data[i];
      }
      return null;
    };

    let mol_medium = 'Artikel';

    let atrMedium = getProp('Medium')?.value;
    switch (atrMedium) {
      case 'DVD':
        mol_medium = 'DVDs';
        break;

      case 'CD':
        mol_medium = 'CDs';
        break;

      case 'Blu-ray':
        mol_medium = 'Blu-rays';
        break;

      case 'Blu-ray 3D':
        mol_medium = '3D Blu-rays';
        break;

      case 'Vinyl / Schallplatte':
        mol_medium = 'Vinyl Schallplatten';
        break;

      case 'CD + DVD':
        mol_medium = 'CD + DVD Sets';
        break;

      case 'SACD':
        mol_medium = 'Super Audio CDs';
        break;

      case 'Maxi Single Schallplatte':
        mol_medium = 'Maxi Single Schallplatten';
        break;

      case 'T-Shirt':
        mol_medium = 'T-Shirts';
        break;

      case 'Musikkassette':
        mol_medium = 'Musikkassetten';
        break;

      case 'Single Schallplatte':
        mol_medium = 'Single Schallplatten';
        break;

      case 'MP3':
        mol_medium = 'MP3s';
        break;

      case 'Blu-ray Audio':
        mol_medium = 'Audio Blu-rays';
        break;

      case 'PC':
        mol_medium = 'PC Spiele';
        break;

      case 'Zubehör':
        mol_medium = 'Zubehör';
        break;

      case 'PS 3':
        mol_medium = 'PlayStation 3 Spiele';
        break;

      case 'PS 4':
        mol_medium = 'PlayStation 4 Spiele';
        break;

      case 'Xbox One':
        mol_medium = 'Xbox One Spiele';
        break;

      case 'CD-ROM':
        mol_medium = 'CD-ROMs';
        break;

      case 'DVD-ROM':
        mol_medium = 'DVD-ROMs';
        break;

      case 'PC/Mac':
        mol_medium = 'PC/Mac Spiele';
        break;

      case 'PS Vita':
        mol_medium = 'PlayStation Vita Spiele';
        break;

      case 'Nintendo 3DS':
        mol_medium = 'Nintendo 3DS Spiele';
        break;

      case 'Nintendo Wii U':
        mol_medium = 'Nintendo Wii U Spiele';
        break;

      case 'Nintendo New 3DS':
        mol_medium = 'Nintendo New 3DS Spiele';
        break;

      case 'Nintendo DS':
        mol_medium = 'Nintendo DS Spiele';
        break;

      case 'Nintendo 2DS':
        mol_medium = 'Nintendo 2DS Spiele';
        break;

      case 'Nintendo Wii':
        mol_medium = 'Nintendo Wii Spiele';
        break;

      case 'Karte/Landkarte':
        mol_medium = 'Karten';
        break;

      case 'Posterbuch':
        mol_medium = 'Posterbücher';
        break;

      case 'Papp-Bilderbuch':
        mol_medium = 'Papp-Bilderbücher';
        break;

      case 'Kalender':
        mol_medium = 'Kalender';
        break;

      case 'Poster':
        mol_medium = 'Poster';
        break;

      case 'Brettspiel':
        mol_medium = 'Brettspiele';
        break;

      case 'Globus':
        mol_medium = 'Globen';
        break;
    }

    let allkeys = [];

    for (let index = 0; index < data.length; index++) {
      allkeys.push(data[index].name);
    }

    let alloweKeys = allowKeysAttribute(allkeys);
    let index = 0;
    return (
      <div>
        <div id="attributeContainer">
          {alloweKeys.map((key) => {
            let item = data.find((s) => s.name == key);

            if (item != null && item.value != '') {
              let addClass = '';
              if (index > 5) {
                addClass = 'extraDetails';
              }
              index = index + 1;

              let itemNameDispalay = replaceAllComplex(item.name, [
                { s: '_', r: ' ' },
              ]);

              let itemsArray = [];

              if (Array.isArray(item.value)) {
                for (let i = 0; i < item.value.length; i++) {
                  itemsArray.push(item.value[i]);
                }
              } else {
                itemsArray.push(item.value);
              }
              return (
                <div
                  className={'wrapperAttribsOptions ' + addClass}
                  key={'atrop' + this.props.details + index}
                >
                  <div className="optionName">
                    <div>{itemNameDispalay}</div>
                  </div>
                  <div className="artikel_detail">
                    <ul className="attribut">
                      {itemsArray.map((item_s, index_s) => {
                        if (item_s != '') {
                          let item_sTransform = replaceAll(
                            replaceAll(item_s, "\\'", "'"),
                            '\\"',
                            '"',
                          );
                          let item_sTransformDispay = item_sTransform;
                          if (item.name == 'Erscheinungsdatum') {
                            item_sTransformDispay = printDE_Date(
                              new Date(item_sTransform),
                            );
                          }

                          if (
                            item_sTransformDispay.indexOf('<img') ||
                            item_sTransformDispay.indexOf('<br') > -1
                          ) {
                            item_sTransformDispay = (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item_sTransformDispay,
                                }}
                              ></span>
                            );
                            item_sTransform = item_sTransform
                              .substr(item_sTransform.indexOf('>') + 1)
                              .trim();
                          }

                          let molLink = {
                            to: '',
                            href: '',
                            title: '',
                          };

                          let linkParams = {
                            href: '',
                            title: '',
                          };

                          if (
                            item.name != shopProductIdLabel &&
                            item.search !== false
                          ) {
                            linkParams.href =
                              this.props.domainPrefix +
                              '/' +
                              item.name +
                              '/' +
                              encodeURIComponent(
                                replaceAllComplex(item_s.toLocaleLowerCase(), [
                                  { s: '/', r: '___' },
                                ]),
                              ) +
                              '/s/';

                            linkParams.title =
                              mol_medium +
                              ' mit ' +
                              item.name +
                              ' ' +
                              item_sTransform;

                            molLink.to =
                              '/search_page/?fqZZZ' +
                              item.name +
                              '=' +
                              encodeURIComponent(
                                replaceAllComplex(item_s.toLocaleLowerCase(), [
                                  { s: '/', r: '___' },
                                ]),
                              );

                            molLink.href = linkParams.href;
                            molLink.title = linkParams.title;
                            return (
                              <li key={'atropLI' + index + '_' + index_s}>
                                <MolLink
                                  to={molLink.to}
                                  key={'atropML' + index + '_' + index_s}
                                  href={molLink.href}
                                  orgHref={molLink.href}
                                  title={molLink.title}
                                >
                                  {item_sTransformDispay}
                                </MolLink>
                              </li>
                            );
                          } else
                            return (
                              <li key={'atropLI' + index + '_' + index_s}>
                                {item_sTransformDispay}
                              </li>
                            );
                        }
                      })}
                    </ul>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}
